import { useCurrentTenant } from "@drift/oneplatfront";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    BoxForm,
    DelegatedForm,
    EntratelForm,
    ExtendedRadioGroup,
    FormHeaderTitle,
    Infobox,
    useWsGet
} from "@onefront/workspace-forms";
import { ExtendedTypography } from "@vapor/react-extended";
import { Box, Button, FormControlLabel, Radio, Stack } from "@vapor/react-material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IntermediaryFooterForm } from "./IntermediaryFooterForm";

export const IntermediaryDelegatedForm = ({ data, onSubmit, onPatch, onBack, loadingPost, loadingPatch, mode }) => {
    const [displayErrors, setDisplayErrors] = useState<any>(false);
    const [errors, setErrors] = useState<any>();
    const [mount, setMount] = useState<any>();
    const [body, setBody] = useState<any>(
        mode === "CREATE"
            ? [
                  {
                      id: "-1",
                      entratelCode: ""
                  }
              ]
            : []
    );
    const [savedEnv, setSavedEnv] = useState<any>(null);
    const [editing, setEditing] = useState<string>(mode === "CREATE" ? "-1" : "");
    const [editingHandle, setEditingHandle] = useState<boolean>(mode === "CREATE");
    const [handle, setHandle] = useState<any>(true);

    const tenant = useCurrentTenant();
    const intermediaryTaxId = useParams().intermediaryTaxId;

    const { data: dataDelegated, fetch: getDelegated, loading: loadingDelegated } = useWsGet("");

    useEffect(() => {
        if (!mount && tenant?.itemId && intermediaryTaxId) {
            setMount(true);
            getDelegated({
                url: `rnd:core:intermediary-registry-read:api://v1/${tenant?.itemId}/intermediary/${intermediaryTaxId}/delegated`,
                params: { withCredentials: true }
            }).then(res => {
                if (res?.data?.length > 0) {
                    setBody(
                        res.data?.map((it: any, index) => {
                            return { ...it, id: index };
                        })
                    );
                    setHandle(true);
                    setEditing("");
                } else if (mode === "CREATE") {
                    setHandle(true);
                }
            });
        }
    }, [mount, getDelegated, tenant, intermediaryTaxId, mode]);

    useEffect(() => {
        if (mode === "EDIT" && dataDelegated?.length === 0) {
            setEditingHandle(true);
        }
    }, [dataDelegated, mode]);

    const handleSubmit = () => {
        if (handle) {
            setDisplayErrors(errors);

            if (Object.keys(errors).some(key => errors[key])) {
                return;
            } else {
                onSubmit(savedEnv, true);
            }
        } else {
            onSubmit([], handle);
        }
    };

    const handleAddSecurityEnv = () => {
        setBody((prev: any) => {
            return [
                ...prev,
                {
                    id: "-1",
                    entratelCode: ""
                }
            ];
        });
        setEditing("-1");
    };

    return (
        <Stack spacing={9} direction="column" maxWidth={741}>
            <Box component={"div"} gap={3} flexDirection={"column"} display={"flex"}>
                <FormHeaderTitle
                    title={"Incaricati"}
                    subtitle="Crea uno o più incaricati associati all’intermediario"
                />

                {data?.type === "P" && mode === "CREATE" && (
                    <Box>
                        <ExtendedRadioGroup
                            label={`Vuoi associare incaricati all’intermediario? ${
                                mode === "CREATE" ? "(opzionale)" : ""
                            }`}
                            value={handle}
                            name={"handle"}
                            onChange={e => {
                                setHandle(e.target.value === "true");
                            }}
                            editing={editingHandle}
                            loading={loadingDelegated}
                        >
                            <FormControlLabel value={true} control={<Radio size="small" />} label="Si" />
                            <FormControlLabel value={false} control={<Radio size="small" />} label="No" />
                        </ExtendedRadioGroup>
                    </Box>
                )}

                {data?.type !== "P" && (
                    <Infobox
                        loading={loadingDelegated}
                        title="Associa incaricato"
                        description="Gli intermediari identificati come persone giuridiche necessitano l’inserimento di un incaricato in quanto persona fisica (che possiede nome e cognome)"
                    />
                )}

                {!loadingDelegated &&
                    handle &&
                    body?.map((box, index) => (
                        <BoxForm
                            key={`security-env-${box.id}`}
                            body={box}
                            editing={editing === box.id}
                            label={`Incaricato 0${index + 1}`}
                            onEdit={id => {
                                setEditing(id);
                            }}
                            onCancel={
                                mode === "EDIT"
                                    ? undefined
                                    : id => {
                                          setDisplayErrors(false);
                                          setBody(prev => {
                                              return prev.filter((item: any) => item.id !== id);
                                          });
                                          setEditing("false");
                                      }
                            }
                            onReset={(id, data) => {
                                setDisplayErrors(false);
                                setBody(prev => {
                                    if (box?.id === "-1") {
                                        return prev.filter((item: any) => item.id !== "-1");
                                    } else {
                                        return prev.map((item: any) => {
                                            if (item.id === box.id) {
                                                return {
                                                    ...item,
                                                    ...data
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                });
                                setEditing("false");
                            }}
                            loading={loadingPatch || loadingPost}
                            onSubmit={id => {
                                setDisplayErrors(errors);
                                if (Object.keys(errors).some(key => errors[key])) {
                                    return;
                                } else if (mode === "CREATE") {
                                    setBody((prev: any) => {
                                        const newBody = prev.map((item: any) => {
                                            if (item.id === "-1") {
                                                return {
                                                    ...item,
                                                    id: index.toString()
                                                };
                                            }
                                            return item;
                                        });
                                        setSavedEnv(newBody);

                                        return newBody;
                                    });
                                    setEditing("false");
                                } else if (mode === "EDIT") {
                                    onPatch?.(box).then(
                                        () => {
                                            setEditing("false");
                                            setBody((prev: any) => {
                                                const newBody = prev.map((item: any) => {
                                                    if (item.id === "-1") {
                                                        return {
                                                            ...item,
                                                            id: index.toString()
                                                        };
                                                    }
                                                    return item;
                                                });
                                                return newBody;
                                            });
                                        },
                                        () => {}
                                    );
                                }
                            }}
                        >
                            <DelegatedForm
                                key="delegated-data"
                                body={box}
                                onChange={(data: any) => {
                                    setBody(prev => {
                                        const updatedBody = prev.map((item: any) => {
                                            if (item.id === box.id) {
                                                return {
                                                    ...item,
                                                    ...data
                                                };
                                            }
                                            return item;
                                        });
                                        setSavedEnv(updatedBody);
                                        return updatedBody;
                                    });
                                }}
                                editing={editing === box.id}
                                onError={(err: any) => {
                                    setErrors((prev: any) => {
                                        return {
                                            ...prev,
                                            ...err
                                        };
                                    });
                                }}
                                displayErrors={displayErrors}
                                required
                                editableFields={{
                                    ...(editing === box.id && {
                                        taxId: mode === "EDIT" && box.id !== "-1" ? false : true
                                    })
                                }}
                            />
                            <Box mt={3}>
                                <ExtendedTypography variant="titleSmall" sx={{ mb: 2 }} display={"block"}>
                                    Utenza Entratel
                                </ExtendedTypography>
                                {editing === box.id && (
                                    <Infobox
                                        title="Dove trovo le credenziali da inserire?"
                                        description={`Sono le credenziali che usi per accedere al sito dell'agenzia delle entrate (Username o Utenza entratel, password e pin)`}
                                        variant="ghost"
                                    />
                                )}
                                <EntratelForm
                                    body={{
                                        ...box,
                                        password: editing !== box.id ? "**********" : box?.password,
                                        pin: editing !== box.id ? "********" : box?.pin
                                    }}
                                    onChange={(data: any, key: any, value: any) => {
                                        setDisplayErrors((prev: any) => {
                                            return {
                                                ...prev,
                                                [key]: false
                                            };
                                        });

                                        setBody(prev => {
                                            const updatedBody = prev.map((item: any) => {
                                                if (item.id === box.id) {
                                                    return {
                                                        ...item,
                                                        ...data
                                                    };
                                                }
                                                return item;
                                            });
                                            setSavedEnv(updatedBody);
                                            return updatedBody;
                                        });
                                    }}
                                    editing={editing === box.id}
                                    onError={(err: any) => {
                                        setErrors((prev: any) => {
                                            return {
                                                ...prev,
                                                ...err
                                            };
                                        });
                                    }}
                                    displayErrors={displayErrors}
                                    required
                                />
                            </Box>
                        </BoxForm>
                    ))}
                {handle && !loadingDelegated && (
                    <Button
                        variant="text"
                        sx={{ width: "fit-content" }}
                        onClick={handleAddSecurityEnv}
                        disabled={editing === "-1"}
                    >
                        <Stack spacing={1} direction={"row"}>
                            <Box>
                                <FontAwesomeIcon icon={faPlusCircle} />
                            </Box>
                            <Box>Aggiungi Incaricato</Box>
                        </Stack>
                    </Button>
                )}
            </Box>

            {mode === "CREATE" && (
                <IntermediaryFooterForm
                    onBack={() => {
                        setDisplayErrors(false);
                        onBack();
                    }}
                    onForward={handleSubmit}
                    disabledForward={loadingPost || (handle && !savedEnv)}
                    loading={loadingPost}
                    isNew={true}
                    lastStep={false}
                />
            )}
        </Stack>
    );
};
